<div id="content" mat-dialog-content>
  @if (isLoading) {
    <div id="conversation-details-loading">
      <app-loading-logo></app-loading-logo>
    </div>
  } @else {
    <div id="avatar-container">
      @switch (conversationType) {
        @case ("Chat") {
          <app-basic-celo-avatar
            [name]="conversationName"
            [userId]="otherParticipantUserId"
            [size]="84"
          />
        }
        @case ("TeamChat") {
          <app-roles-icon [backgroundSize]="'84px'" [size]="'67.2px'" />
        }
        @default {
          <app-celo-avatar
            [width]="84"
            [height]="84"
            [type]="conversationType"
            [conversationPictureUri]="this.conversationPhotoUrl"
          ></app-celo-avatar>
        }
      }
    </div>
    <h2 id="title" class="mat-title">
      {{ conversationName }}
    </h2>
  }

  <p id="description">Incoming call</p>
</div>

<mat-dialog-actions align="center">
  <button
    mat-button
    class="celo-secondary-button uppercase"
    (click)="onDecline()"
  >
    Decline
  </button>
  <button
    mat-button
    class="celo-primary-button uppercase"
    (click)="onJoin()"
    [disabled]="isActioned"
  >
    Join
  </button>
</mat-dialog-actions>
